export default __webpack_public_path__ + "static/media/tutorial-set-policies-3.93d0597c.png";